import { render } from "./WildBookObserveSpecLocation.vue?vue&type=template&id=24c30b6c&scoped=true&ts=true"
import script from "./WildBookObserveSpecLocation.vue?vue&type=script&lang=ts"
export * from "./WildBookObserveSpecLocation.vue?vue&type=script&lang=ts"

import "./WildBookObserveSpecLocation.vue?vue&type=style&index=0&id=24c30b6c&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c30b6c"]])

export default __exports__